export default {
  data() {
    return {
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
    };
  },
  methods: {
    formatMonto(monto) {
      return new Intl.NumberFormat('es-BO', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(monto);
    },

    formatFecha(fecha) {
      if (!fecha) return 'N/A';
      const [anio, mes, dia] = fecha.split('-');
      return `${dia}/${mes}/${anio}`;
    },

    getColorEstado(estado) {
      const colores = {
        vigente: 'green',
        retrasado: 'orange',
        'por recuperar': 'red',
      };
      return colores[estado] || 'grey';
    },

    getIniciales(nombre) {
      if (!nombre) return '?';
      const partes = nombre.split(' ');
      return partes.map(p => p[0]).join('').substring(0, 2).toUpperCase();
    },

    calcularDiasRetraso(fechaLimite) {
      const hoy = new Date();
      const limite = new Date(fechaLimite);
      const diff = Math.floor((hoy - limite) / (1000 * 60 * 60 * 24));
      return diff > 0 ? diff : 0;
    },

    mostrarNotificacion(texto, color = 'success') {
      this.snackbarText = texto;
      this.snackbarColor = color;
      this.snackbar = true;
    },
  },
};
